import React, { FC } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { navigate } from 'hookrouter'

// import { BackButton } from 'components/BackButton/BackButton'
import { createTemplateDocument } from 'state/async_actions'
// import { ErrorsDisplay } from '../ErrorsDisplay'
import { Field } from 'models/Field'
import { Field as IField, UrlParams } from 'types'
import { TemplateDocumentEditor } from 'components/TemplateDocumentEditor'
import { useAnnotations } from 'hooks/useAnnotations'
import { useAppContext } from 'state/context'
import { useForm } from 'hooks/useForm'
import { fetchTemplateDirectories } from 'hooks/useDataLoader'

interface InputProps {
  title: string
  file: File
  fieldsAttributes: IField[],
  template_directory_id?: number | string
}

 interface directoryParam { directoryId?:number}
 interface subDirectoryParam { subDirectoryId?:number}
type urlParams = UrlParams & directoryParam & subDirectoryParam
export const NewProjectTemplateDocumentForm: FC<urlParams> = ({
  projectId,
  companyId,
  directoryId,
  subDirectoryId
}) => {
  const [, dispatch] = useAppContext()
  const [
    annotations,
    currentAnnotation,
    setAnnotation,
    addAnnotation,
    ,
    ,
    deleteAnnotation,
  ] = useAnnotations()

  const [{ title, file }, handleInputChange, handleSubmit, validated] = useForm<
    InputProps
  >(async submittedInputs => {
    const fieldsAttributes = annotations.map(Field.fromAnnotation)

    submittedInputs = {
      ...submittedInputs,
      fieldsAttributes,
    }

    submittedInputs.template_directory_id = subDirectoryId ? subDirectoryId : (directoryId ? directoryId : '')

    await createTemplateDocument(dispatch, projectId, submittedInputs)
    fetchTemplateDirectories(dispatch, projectId, directoryId, subDirectoryId)
    if(subDirectoryId)
       navigate(`/company/${companyId}/project/${projectId}/directory/${directoryId}/subFolder/${subDirectoryId}`)
    else if(directoryId)
      navigate(`/company/${companyId}/project/${projectId}/directory/${directoryId}`)
    else
    navigate(`/company/${companyId}/project/${projectId}`)

  })

  return (
    <>
      <Row>
        <Col>
          <h1>Create a new Template</h1>
          {/* <ErrorsDisplay /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                required
                onChange={handleInputChange}
                value={title || ''}
                name="title"
                type="text"
                placeholder="Enter Title"
              />
              <Form.Control.Feedback type="invalid">
                Please enter a title for your template.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formFile">
              <Form.Label>PDF File</Form.Label>
              <Form.Control
                accept="application/pdf"
                required
                onChange={handleInputChange}
                name="file"
                type="file"
              />
              <Form.Control.Feedback type="invalid">
                Please choose a PDF document from your device.
              </Form.Control.Feedback>
            </Form.Group>

            <Button
              className="btn-icon-plus"
              variant="primary"
              value="Upload new Template"
              type="submit">
              Upload new Template
            </Button>
            {/* <BackButton /> */}
          </Form>
        </Col>
        <Col>
          {file ? (
            <TemplateDocumentEditor
              currentAnnotation={currentAnnotation || {}}
              annotations={annotations}
              setAnnotation={setAnnotation}
              addAnnotation={addAnnotation}
              deleteAnnotation={deleteAnnotation}
              file={file}
              projectId={projectId}
            />
          ) : null}
        </Col>
      </Row>
    </>
  )
}
